import {serverApi} from '../../api/serverAPI'


const datas = {
    updatePassword: (args) => new Promise((resolve, reject) => {
 
        serverApi.post('/auth/new-password',{current_password:args.current_password,password:args.password,id:args.id,newDate:args.newDate})
        .then(function (response) {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
      }),
      getHolidays:(args )=> new Promise((resolve, reject) => {
serverApi.post('/storage/holidays',{userId:args}).then(function (response) {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
      }),
      getUserId:(args )=> new Promise((resolve, reject) => {
        timeApi.getUser(args).then(function (response) {
                  resolve(response)
                })
                .catch((error) => {
                  reject(error)
                })
              })
}
export default datas


// WEBPACK FOOTER //
// ./src/components/User/api.js